module.exports = __webpack_public_path__ + "img/productHSE_21.8200777f.png";